@if(canMakePayment)
{
<div nestableForm name="form">
  <div class="google-pay-button" (click)="googlePay()"
       aria-label="Pay with Google Pay">
    <span class="google-logo" aria-hidden="true"></span>
    <span class="sr-only">Pay with Google Pay</span>
  </div>
</div>
}
